
import { useState } from 'react';
import HeroSection from './components/HeroSection';
import ValueProposition from './components/ValueProposition';
import HawaiiIntro from './components/HawaiiIntro';
import Itinerary from './components/Itinerary';
import Highlights from './components/Highlights';
import Pricing from './components/Pricing';
import Services from './components/Services';
import Conditions from './components/Conditions';
import Gallery from './components/Gallery';
import VideoSection from './components/VideoSection';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function Home() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Handle scroll to top button visibility
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setShowScrollTop(window.scrollY > 500);
    });
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <ValueProposition />
      <HawaiiIntro />
      <Itinerary />
      <Highlights />
      <Pricing />
      <Services />
      <Conditions />
      <Gallery />
      <VideoSection />
      <Testimonials />
      <FinalCTA />
      <Footer />
      
      {/* Scroll to top button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-r from-blue-500 to-teal-400 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center z-50 hover:scale-110"
          aria-label="Scroll to top"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </div>
  );
}
